import { ReminderStatusEnum } from "web_myplann/Infrastructure/Api/Api";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";

export const ReminderBadgeVariant = {
	None: "none",
	Soon: "soon",
	Overdue: "overdue",
	Snoozed: "snoozed",
} as const;

export type ReminderBadgeVariant =
	(typeof ReminderBadgeVariant)[keyof typeof ReminderBadgeVariant];

const STATUS_TO_BADGE: Record<ReminderStatusEnum, ReminderBadgeVariant> = {
	[ReminderStatusEnum.Active]: ReminderBadgeVariant.None,
	[ReminderStatusEnum.Soon]: ReminderBadgeVariant.Soon,
	[ReminderStatusEnum.Overdue]: ReminderBadgeVariant.Overdue,
	[ReminderStatusEnum.Snoozed]: ReminderBadgeVariant.Snoozed,
	[ReminderStatusEnum.Solved]: ReminderBadgeVariant.None,
};

export const resolveReminderBadge = (
	reminder: Reminder,
): ReminderBadgeVariant => STATUS_TO_BADGE[reminder.status];
